import script from "./CollapsibleSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsibleSection.vue?vue&type=script&setup=true&lang=ts"

import "./CollapsibleSection.vue?vue&type=style&index=0&id=7c1edbbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c1edbbe"]])

export default __exports__